import { EventRegistrationStatus } from "@bindeleddet/core/types";

const GREY = "#dae9f6";
const GREEN = "#ddecea";
const YELLOW = "#fcf4dc";
const RED = "#f4dada";
const BLUE = "#dcebfa";

export const COLORS_PER_STATUS: Record<EventRegistrationStatus, string> = {
  AVAILABLE: GREEN,
  FULL: GREY,
  NOT_OPEN: GREY,
  NOT_RELEVANT: GREY,
  REGISTERED: GREEN,
  REGISTERED_FOR_WAITLIST: YELLOW,
  WAITLIST_AVAILABLE: GREEN,
  BANNED: RED,
  EXTERNAL_BOOKING: BLUE,
};

export const LABELS_PER_STATUS: Record<EventRegistrationStatus, string> = {
  AVAILABLE: "Aktuell",
  FULL: "Fullt",
  NOT_OPEN: "Ikke åpnet",
  NOT_RELEVANT: "Ikke relevant",
  REGISTERED: "Påmeldt",
  REGISTERED_FOR_WAITLIST: "Påmeldt venteliste",
  WAITLIST_AVAILABLE: "Venteliste tilgjengelig",
  BANNED: "Du er utestengt",
  EXTERNAL_BOOKING: "Søknadsbasert",
};
